module.exports = __webpack_public_path__ + "img/mallorca.15cb43ab.png";